<div class="messages">
  <achoo-infinite-scroll [scrollDistance]="scrollDistance"
                         [scrollDistanceUp]="scrollUpDistance"
                         [infiniteScrollThrottle]="throttle"
                         [infiniteScrollContainer]="'.recent-messages-container'"
                         [scrollWindow]="false"
                         [fromRoot]="true"
                         (scrollDownEvent)="onScrollDown()">
    <conversation-item *ngFor="let conversation of conversations"
                       [conversation]="conversation"
                       [editable]="editable"
                       (removeConversation)="onRemoveConversation($event)"
                       (select)="onSelectConversation($event)">
    </conversation-item>
  </achoo-infinite-scroll>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer-inbox/conversation-list/conversation-list.component.html